/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */
import * as React from 'react';

import { FlatTable, FlatTableBody } from 'carbon-react/lib/components/flat-table';

import { useIntl } from '@futrli/localisation';

import { AccountRow } from './account-row';
import { ActiveMode, COADisplayAccount } from '../../types';
import { CategoryTableHeader } from './category-table-header';
import { CategoryTableStyles } from './category-table-styles';
import { DragHandlers } from '../../hooks/useCategoryDragDrop';
import { GroupRow } from './group-row';

import * as styles from './category-table.scss';

interface Props {
  tableData: COADisplayAccount[];
  isBalanceSheet: boolean;
  accountNameMap?: Record<string, string>;
  activeMode?: ActiveMode;
  categoryName?: string;
  drag: DragHandlers;
  isUpdatingStructure: boolean;
}

export const CategoryTable = ({
  tableData,
  isBalanceSheet,
  accountNameMap,
  activeMode,
  categoryName,
  drag,
  isUpdatingStructure
}: Props) => {
  const intl = useIntl();

  const flatIndexMap = React.useMemo(() => {
    const map: Record<string, number> = {};
    tableData.forEach((item, index) => {
      map[item.id] = index;
    });
    return map;
  }, [tableData]);

  const isReorderingMode = activeMode === ActiveMode.REORDERING;

  return (
    <div className={`${styles.container} ${isReorderingMode ? 'reordering-mode-active' : ''}`}>
      <CategoryTableStyles />
      <FlatTable
        title={
          categoryName
            ? intl.formatMessage(
                { id: 'predict.category_accounts_table', defaultMessage: '{category} accounts' },
                { category: categoryName }
              )
            : undefined
        }
      >
        <CategoryTableHeader isBalanceSheet={isBalanceSheet} />
        <FlatTableBody>
          {tableData
            .filter(row => row.depth === 0)
            .map(row => {
              if (row.type === 'group') {
                return (
                  <GroupRow
                    key={row.id}
                    row={row}
                    isBalanceSheet={isBalanceSheet}
                    accountNameMap={accountNameMap}
                    activeMode={activeMode}
                    index={flatIndexMap[row.id]}
                    drag={drag}
                    categoryName={categoryName}
                    flatIndexMap={flatIndexMap}
                    isUpdatingStructure={isUpdatingStructure}
                  />
                );
              }
              return (
                <AccountRow
                  key={row.id}
                  row={row}
                  isBalanceSheet={isBalanceSheet}
                  accountNameMap={accountNameMap}
                  activeMode={activeMode}
                  index={flatIndexMap[row.id]}
                  drag={drag}
                  categoryName={categoryName}
                  isUpdatingStructure={isUpdatingStructure}
                />
              );
            })}
        </FlatTableBody>
      </FlatTable>
    </div>
  );
};
